export default {
    Metadata: {
        Name: "IsThisMonth",
        Description: "Returns whether or not a given date occurs in the current month.",
        Syntax: "IsThisMonth(date)",
        Keywords: ['Date'],
        Author: "DataVoke, Inc.",
    },
    execute(newDate) {
        var d = Date.now(),
            date = app.dv.helpers.exprEng.expr.todate(newDate);
        if (d.getMonth() == date.getMonth()) {
            return true;
        }
        return false;
    },
};

